import React from "react";
import { Menu } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  ProjectOutlined,
  CreditCardOutlined,
  UpOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import "./PnsSider.css";
import { useSelector } from "react-redux";
import Axios from "axios";
import constants from "../constants/constants.json";

export default function PnsSider(props) {
  const user = useSelector((state) => state.userReducer.personal);
  const history = useHistory();

  const logout = async () => {
    try {
      await Axios.get(constants.url + "/user/logout");
      localStorage.removeItem("pnsToken");
      history.replace("/login")
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="pns-sider">
      <img
        src={require("../images/logo.png")}
        style={{ width: "100px", alignSelf: "center", objectFit: "cover" }}
      />
      <Menu mode="inline" theme="light">
        {/* <Menu.Item
          onClick={() => history.push("/dashboard")}
          key="1"
          icon={<DashboardOutlined />}
        >
          Dashboard
        </Menu.Item> */}
        <Menu.Item
          onClick={() => history.push("/dashboard/projects")}
          key="2"
          icon={<ProjectOutlined />}
        >
          Projects
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            history.push("/dashboard/plans");
          }}
          key="3"
          icon={<UpOutlined />}
        >
          Plans
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            history.push("/dashboard/billings");
          }}
          key="4"
          icon={<CreditCardOutlined />}
        >
          Billings
        </Menu.Item>
        <Menu.Item
          onClick={() => history.push("/dashboard/profile")}
          key="5"
          icon={<UserOutlined />}
        >
          Profile
        </Menu.Item>
        {user.roleAdmin && (
          <Menu.SubMenu key="6" title="admin" icon={<DashboardOutlined />}>
            <Menu.Item
              key="7"
              onClick={() => history.push("/dashboard/admin/users")}
              // icon={<UserOutlined />}
            >
              users
            </Menu.Item>
            <Menu.Item
              key="8"
              onClick={() => history.push("/dashboard/admin/payments")}
              // icon={<UserOutlined />}
            >
              paymnets
            </Menu.Item>
            <Menu.Item
              key="9"
              onClick={() => history.push("/dashboard/admin/invoices")}
              // icon={<UserOutlined />}
            >
              invoices
            </Menu.Item>
          </Menu.SubMenu>
        )}
        <Menu.Item onClick={logout} key="2" icon={<LogoutOutlined />}>
          Exit
        </Menu.Item>
      </Menu>
    </div>
  );
}
